// @ts-strict-ignore
import React from 'react'
import { capabilitiesErrorAtom } from 'atoms/capabilities'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { PermissionsDenied } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ExternalLinks } from 'constants/links'
import { logSentryErrorAndGetTraceId } from 'utils/sentry'
import { customerModelAtom } from './atoms/customersAtoms'
import { CustomersList } from './CustomersList/CustomersList'

export const Customers = () => {
  const { t } = useTranslation()
  const customerModel = useAtomValue(customerModelAtom)

  const capabilitiesError = useAtomValue(capabilitiesErrorAtom)

  if (capabilitiesError) {
    const sentryTraceId = logSentryErrorAndGetTraceId(
      `Failed API request to /v1/capabilities/bulk with status ${capabilitiesError?.status}`,
      capabilitiesError
    )

    return <RequestErrorStatusCard sentryTraceId={sentryTraceId} />
  }

  if (customerModel) return <CustomersList customerModel={customerModel} />

  return (
    <PermissionsDenied
      description={
        <>
          <span>{t('customers.notEnabledDescription')}</span>
          <ExternalLink href={ExternalLinks.EMBEDDED_WALLETS_LEARN_MORE}>
            {t('learnMore')}
          </ExternalLink>
        </>
      }
    />
  )
}
